import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapsibleCardProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  action?: React.ReactNode;
}

export const CollapsibleCard = ({
  title,
  children,
  defaultOpen = true,
  action = null,
}: CollapsibleCardProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Card className="shadow-sophisticated border-none transition-all duration-200">
      <CardHeader
        className="py-4 cursor-pointer hover:bg-muted/30 border-b border-border/50"
        onClick={(e) => {
          // Don't toggle if clicking on the action button
          if (
            action &&
            (e.target as HTMLElement).closest("button:not(.collapse-toggle)")
          ) {
            return;
          }
          setIsOpen(!isOpen);
        }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <CardTitle className="text-lg font-semibold">{title}</CardTitle>
            {action && <div onClick={(e) => e.stopPropagation()}>{action}</div>}
          </div>
          <div className="bg-muted/50 p-1 rounded-full">
            {isOpen ? (
              <ChevronUp className="h-4 w-4 text-muted-foreground" />
            ) : (
              <ChevronDown className="h-4 w-4 text-muted-foreground" />
            )}
          </div>
        </div>
      </CardHeader>
      {isOpen && <CardContent className="p-6 animate-in slide-in-from-top-2 duration-200">{children}</CardContent>}
    </Card>
  );
};
